<template>
  <div :class="'appInfo ' + billing.billtextFlow">
    <template v-if="billing.billLogo">
      <img
        :class="billing.billLogoRound ? 'rounded-circle' : ''"
        :src="'/storage/' + configs.logoBill"
        :width="billing.billLogoWidth"
        :height="billing.billLogoHeight"
      >
    </template>
    <h4 v-if="billing.billAppName">
      {{ configs.site_name }}
    </h4>
    <template v-if="billing.billAddress">
      <h5>{{ configs.address_1 }}</h5>
      <h5 v-if="configs.address_2">
        {{ configs.address_2 }}
      </h5>
      <h5 v-if="configs.address_3">
        {{ configs.address_3 }}
      </h5>
    </template>
    <h5 v-if="billing.billPhone">
      {{ configs.phone }}
    </h5>
    <h6 v-if="billing.billType">
      <template v-if="order.salling">
        Sale Payment:
      </template>
      <template v-if="order.refunding">
        Refund Payment:
      </template>
      <template v-if="order.purchasing">
        <h3>Reference: {{ order.reference | uppercase }}</h3>
      </template>
      <template v-if="order.dueDate">
        {{ paymentStatus ? "Paid" : "Due Till " + order.dueDate }}
      </template>
    </h6>
    <template v-if="billing.billBarcode">
      <img
        :src="order.barcode"
        :class="order.purchasing ? 'buy' : 'sale'"
      >
    </template>
    <div class="d-flex mt-0 md-text">
      <template v-if="billing.billDateTime">
        {{ order.created_at }}
      </template>
      <v-spacer />
      <template v-if="billing.billBy">
        By:{{ order.by | capitalize }}
      </template>
      <v-spacer />
      <template v-if="billing.billRefrence">
        TR # {{ order.key }}
      </template>
    </div>
    <hr>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex";
export default {
  props: {
    order: { required: true, type: Object, default: null },
  },
  computed: {
    ...mapGetters({
      configs: "configs/overall",
      billing: "configs/billing",
    }),
    paymentStatus() {
      if (this.order != null && "payment" in this.order) {
        return this.order.payment.status;
      }
      return null;
    },
  },
};
</script>
<style type="text/css">
.appInfo {
  font-family: Arial !important;
}
.sale {
  width: 98%;
  height: 18px;
  background-color: white;
}
.buy {
  width: 200px;
  height: 25px;
}
</style>
